export const ACTIONS = {
    SHOW_HIDE_CART : 'SHOW_HIDE_CART',
    ADD_TO_CART : 'ADD_TO_CART',
    DELETE_FROM_CART : 'DELETE_FROM_CART',
    CLEAR_CART : 'CLEAR_CART',
    UPDATE_QUANTITY : 'UPDATE_QUANTITY',
}